// extracted by mini-css-extract-plugin
export var animationContainer = "_g8-0";
export var asteriskIcon = "_g8-8";
export var conversationLeftSection = "_g8-4";
export var conversationListItem = "_g8-3";
export var conversationMiddleSection = "_g8-5";
export var conversationRightSection = "_g8-6";
export var detailsContent = "_g8-1";
export var listContainer = "_g8-7";
export var modalContent = "_g8-2";